const BASE_TITLE = "KYVU";

export const resolveAppTitle = () => {
  if (import.meta.env.DEV) {
    return `${BASE_TITLE} - Local`;
  }

  const deployBranch = (import.meta.env.VITE_DEPLOY_BRANCH ?? "")
    .toString()
    .trim()
    .toLowerCase();

  if (deployBranch === "develop") {
    return `${BASE_TITLE} - Develop`;
  }

  return BASE_TITLE;
};

export const applyAppTitle = () => {
  if (typeof document === "undefined") return;
  document.title = resolveAppTitle();
};
